/**
 * Client-side route paths. Kept dependency-free so navigation and pages can import it
 * without pulling in the router tree.
 */
export const routePaths = {
    today: '/',
    history: '/history',
    insights: '/insights',
    settings: '/settings',
    signIn: '/sign-in',
    signUp: '/sign-up',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
    verifyEmail: '/verify-email',
    checkEmail: '/check-email',
    onboarding: '/onboarding',
    invite: '/invite/:token',
} as const;

export type RoutePath = (typeof routePaths)[keyof typeof routePaths];
